
<div class="tabs-container">
  
    <mat-tab-group mat-stretch-tabs="true" animationDuration="200ms" class="tabs-group">

        <!-- Tab - New user -->
        <mat-tab label={{languageService.Strings.messages.section_newUser}}>

            <form [formGroup]="formControlGroup" class=global-container>

                <!-- Input - Email -->
                <div class="input_box">
                    <mat-form-field class="input-text noraml-text-size" appearance="fill">
                        <mat-label>
                            {{languageService.Strings.messages.input_box_email}}
                        </mat-label>
                        <input class="input-test"
                            matInput
                            id="email"
                            type="email" 
                            placeholder="" 
                            [formControl]="formControl_email" 
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="formControl_email.hasError('email') ||  
                                        formControl_email.hasError('spacesInStringValidationError') ||
                                        formControl_email.hasError('required')" >
                            {{languageService.Strings.errors.format_error_email}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Button - Mat Menu - Region -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuRegion_NewUser" 
                    >
                        {{languageService.Strings.buttons.button_targetRegion}}: {{optionMenu_Region_value_NewUser}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 
                
                <!-- Button - Mat Menu - Language -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuLanguageCode_NewUser" 
                    >
                        {{languageService.Strings.buttons.button_targetLanguage}}: {{optionMenu_LanguageCode_value_NewUser}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Menu - Region -->
                <mat-menu #menuRegion_NewUser="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_Region_OptionList; let i=index"
                    (click)="optionMenuClick_Region_NewUser(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Menu - Language -->
                <mat-menu #menuLanguageCode_NewUser="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_LanguageCode_OptionList; let i=index"
                    (click)="optionMenuClick_LanguageCode_NewUser(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Button - Create license -->        
                <button mat-raised-button 
                        color="primary" 
                        class="base_buttons" 
                        (click)="buttonClicked_craeteLicense()" 
                        [disabled]="!formIsValid()"> 
                    {{languageService.Strings.buttons.button_createLicense}}
                </button>

                <!-- Label - Display password -->
                 <div *ngIf="result_password.length > 0" 
                    class="password-panel button_with_icon noraml-text-size"
                    (click)="buttonClicked_copyPasswordToClipboard()"
                    >
                    {{languageService.Strings.messages.output_password}}: {{result_password}}
                    <mat-icon iconPositionEnd>content_copy</mat-icon>
                 </div>
                
            </form>


        </mat-tab>


        <!-- Tab - Existing user -->
        <mat-tab label={{languageService.Strings.messages.section_existingUsers}}>

            <!-- User list -->
             <div class=global-container>

                <!-- Button - Mat Menu - Region -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuRegion_ExistingUsers" 
                    >
                        {{languageService.Strings.buttons.button_targetRegion}}: {{optionMenue_Region_value_ExistingUsers}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Menu - Region -->
                <mat-menu #menuRegion_ExistingUsers="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_Region_OptionList; let i=index"
                    (click)="optionMenuClick_Region_ExistingUsers(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- List - Existing users -->
                <div class="scrollable-list-container" *ngIf="list_ExistingUsers.length > 0">
                    <mat-list role="list">

                        <ng-container *ngFor="let item of list_ExistingUsers; let last = last">
            
                            <mat-list-item role="listitem">
                                <mat-icon matListItemIcon>person</mat-icon>

                                <span matListItemTitle>{{ item }}</span>

                                <div matListItemMeta class="action-buttons">
                                    
                                    <button mat-icon-button color="warn" (click)="buttonClicked_userSettings(item)">
                                        <mat-icon>settings</mat-icon>
                                    </button>

                                    <button mat-icon-button color="warn" (click)="buttonClicked_deleteUser(item)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    
                                </div>
                            </mat-list-item>

                            <mat-divider *ngIf="!last" class="divider"></mat-divider>

                        </ng-container>
                    </mat-list>
                </div>
                

             </div>


        </mat-tab>
    
    
    
    
    
    </mat-tab-group>

</div>


<!-- Waiting spinner -->
<div *ngIf="(displayWaitingPopup)" >
    <app-waiting-popup [waitingMessage]="waitingMessage" ></app-waiting-popup> 
</div>